"use client";

import { getIcon } from "@litonarefin/utils/icons";
import { useState } from "react";
import StyledIcon from "@litonarefin/components/StyledIcon";
import FeatureList from "./FeatureList";

const tabs = [
    {
        id: 1,
        tabName: "Details",
        icon: getIcon("file"),
    },
    {
        id: 2,
        tabName: "Product Info",
        icon: getIcon("info"),
    },
];

function ProductInfo({ details, product_info }) {
    const [active, setActive] = useState(1);

    return (
        <div>
            <div className="jlt-flex jlt-items-center">
                {tabs?.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActive(tab.id)}
                        className={`jlt-py-4 jlt-px-6 jlt-text-base jlt-tracking-wide jlt-flex jlt-items-center jlt-gap-2 ${
                            active === tab.id
                                ? "jlt-border-r jlt-border-l jlt-border-t jlt-text-[#344054] jlt-rounded-t"
                                : "jlt-border-b jlt-text-[#98A2B3]"
                        } last:jlt-w-full last:jlt-text-left`}>
                        <StyledIcon color={active === tab.id ? "#344054" : "#98A2B3"} type="stroke">
                            {tab.icon}
                        </StyledIcon>
                        <span>{tab.tabName}</span>
                    </button>
                ))}
            </div>

            {active === 1 ? (
                <div className="jlt-mt-8 jlt-flex jlt-flex-col jlt-gap-4">
                    <FeatureList label={"MIT License"} icon={"education"} rightIcon="question" />
                    <FeatureList
                        label={"Downloads"}
                        icon={"downloads"}
                        rightLabel={`${details?.download_count || 0}`}
                    />
                    <FeatureList label={"Version"} icon={"layout"} rightLabel={details?.version} />
                    <FeatureList
                        label={"Changelog"}
                        icon={"changelog"}
                        rightLabel="View"
                        rightColor="#FB346D"
                        link={`/${details?.changelog}`}
                    />
                    <FeatureList
                        label={"Updated"}
                        icon={"rotateArrows"}
                        rightLabel={details?.update_on}
                    />
                    <FeatureList
                        label={"Released"}
                        icon={"timeCalendar"}
                        rightLabel={details?.released_on}
                    />
                    <FeatureList
                        label={"Reviews"}
                        icon={"loveCheck"}
                        rightLabel={`${details?.review_count || 0} Reviews`}
                        rightColor="#FB346D"
                        link={"#jlt_ra_review"}
                    />
                </div>
            ) : (
                <div className="jlt-mt-8 jlt-flex jlt-flex-col jlt-gap-4">
                    <FeatureList
                        label={"Handcrafted Elements"}
                        icon={"grid"}
                        rightLabel={`${product_info?.handcrafted_elements || 0}`}
                    />
                    <FeatureList
                        label={"Customized Plugins"}
                        icon={"puzzle"}
                        rightLabel={`${product_info?.customized_plugins || 0}`}
                    />
                    <FeatureList
                        label={"Example Pages"}
                        icon={"file"}
                        rightLabel={`${product_info?.example_pages || 0}`}
                    />
                    <FeatureList
                        label={"Premium Support"}
                        icon={"support"}
                        rightLabel={`${product_info?.premium_support}`}
                    />
                    <FeatureList
                        label={"Well Documented"}
                        icon={"file"}
                        rightLabel={`${product_info?.well_documented}`}
                    />
                    <FeatureList
                        label={"Fully Responsive"}
                        icon={"mobile"}
                        rightLabel={`${product_info?.fully_responsive}`}
                    />
                </div>
            )}
        </div>
    );
}

export default ProductInfo;
